import {AbstractFetcher} from '@/common/services/fetcher/AbstractFetcher';
import {LocationType} from '@/common/constants/locationType';
import {alpha2ToAlpha3LanguageCode} from '@/common/constants/language';
import {parseLocationPoint} from '../helpers/locationHelpers';

export const getSearchSuggests =
	(fetcher: AbstractFetcher) =>
	async (searchString: string, lang: string, limit: number, locationTypes?: LocationType[]) => {
		const response = await fetcher.fetch<{locations: any[]}>('/api/search/suggest', {
			/* eslint-disable @typescript-eslint/naming-convention */
			query: searchString,
			lang: alpha2ToAlpha3LanguageCode[lang],
			limit,
			location_types: locationTypes,
			/* eslint-enable @typescript-eslint/naming-convention */
		});

		return response.locations.map(parseLocationPoint);
	};

export const getSearchHistory = (fetcher: AbstractFetcher) => async (lang: string, limit: number) => {
	const response = await fetcher.fetch<{history: any[]}>('/api/search/history/list/all', {
		lang: alpha2ToAlpha3LanguageCode[lang],
		limit,
	});

	return response.history.map(parseLocationPoint);
};
